import { Metrohoudai } from '@linktivity/link-connect';
import config from '../config';

const paymentApi = new Metrohoudai.PaymentApi(config);

export default paymentApi;
